import React, {Component} from "react";
import PropTypes from "prop-types";
import {Redirect} from 'react-router';
import {NavLink} from 'react-router-dom';
import Loader from '../Loader'
import api from "../../api/Api";
import localStorageHelper from "./../../localStorageHelper"

import ReactTable from "react-table";
import "react-table/react-table.css";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";
import Datetime from "react-datetime";
import moment from "moment";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";

import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
// core components
import GridItem from "components/Grid/GridItem.jsx";
//import Table from "components/Table/Table.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardText from "components/Card/CardText.jsx";
import matchSorter from 'match-sorter';
import Button from "components/CustomButtons/Button.jsx";
import Icon from '@material-ui/core/Icon';
import Person from "@material-ui/icons/Person";
import SearchComponent from "components/Search/AutoCompletePatient.jsx";

//import AlertBox from 'components/AlertBox/alertbox.jsx';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';

import GridContainer from "components/Grid/GridContainer.jsx";

import {mappingUI,dashboardRouter} from '../../util/globalHelper';
import {titleCase} from '../../util/globalHelper';
import Permissions from '../../util/globalPermissions';
import {getDateConverter, signOut} from '../../util/globalHelper';

const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    AutoCompleteClass: {
        width: '100%',
        padding: 0,
        margin:'20px 0',
        height: 0,
        position: 'inherit'
    }
};
class ProfileView extends Component {
    constructor() {
        super();
        this.state = {
            data: null,
            clinicsData: null,
            simpleSelect: "",
            doctorsData: null,
            start_date: "",
            end_date: "",
            clinic_id: "",
            doctor_id: "",
            patientId: "",
            type: ""
        };
        this.onChangeSelect = this.onChangeSelect.bind(this)
    }

    handleChangeStartDate(event) {
        this.setState({start_date: event.format('YYYY-MM-DD')});
    }

    handleChangeEndDate(event) {
        this.setState({end_date: event.format('YYYY-MM-DD')});
    }

    handleSimple = event => {
        this.setState({[event.target.name]: event.target.value});
    };

    CallReadApi = () => {
        this.setState({data: JSON.parse(localStorage.getItem("user_detail"))})
    };

    componentDidMount() {
        this.CallReadApi();
    }



    getSuggestionValue = (suggestion) => {
        this.setState({
            patientId: suggestion._id,

        });
        return suggestion.user_id.name


    }

    onChangeSelect(e) {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState(state);
    }

    render() {
        const {data} = this.state;
        const {classes} = this.props;
        if (this.state.data)
            return (
                <div>
                    {this.state.alert}
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                            <Card>
                                <CardHeader color="info" text>
                                    <CardText color="info">
                                        <GridContainer>
                                            <GridItem>
                                                <Person/>
                                            </GridItem>
                                            <GridItem>
                                                <h4 className={classes.cardTitleWhite}>My Profile</h4>
                                            </GridItem>
                                        </GridContainer>
                                    </CardText>
                                </CardHeader>
                                <CardBody>
                                    <GridContainer justify="center">
                                        <GridItem xs={12} sm={10} md={8}>

                                            <GridContainer>
                                                <GridItem>
                                                    <h2>{data && data.name && data.name ? data.name : "No Name"}</h2>
                                                </GridItem>
                                            </GridContainer>

                                            <GridContainer>
                                            
                                                <GridItem xs={12} md={6}>
                                                    <h5>
                                                        <b>{data && data.contact ? data.contact : "No Contact"}</b>
                                                    </h5>
                                                    <h5>
                                                        <b>{data && data.email ? data.email : "No Email"}</b>
                                                    </h5>
                                                </GridItem>
                                                <br /><br />
                                                <GridItem xs={12} md={6}>
                                                    <h5>
                                                        <b>Role: {localStorageHelper.getItem("superAdmin")? "Super Admin" : localStorageHelper.getItem("selected_role").clinic_permission_id.role_name}</b>
                                                    </h5>
                                                    <h5>
                                                        <b>Status: {data && data.status ? data.status : "Inactive"}</b>
                                                    </h5>
                                                </GridItem>
                                                <GridItem>
                                                    <h5>
                                                        {/*<b>Reason: {data && data.notes ? data.notes : null}</b>*/}
                                                    </h5>
                                                </GridItem>
                                            
                                            </GridContainer>

                                            <GridItem>
                                                <br/>
                                                <br/>
                                            </GridItem>

                                        </GridItem>
                                        <GridItem>
                                            <br /><br />
                                            <GridItem>
                                                <NavLink
                                                    to={dashboardRouter(`/user/role/update/clinicmaster/${data.roles[0].clinic_master_id._id}/${data._id}`)}>
                                                    <Button block className="width-full" color="warning">
                                                        <Icon>border_color</Icon>
                                                        <span style={{paddingLeft: 10}}>Update</span>
                                                    </Button>
                                                </NavLink>
                                                <br/>
                                                <Button block className="width-full" color="simple" onClick={() => signOut()}>
                                                    <Icon>exit_to_app</Icon>
                                                    <span style={{paddingLeft: 10}}>Logout</span>
                                                </Button>
                                                <br/>
                                            </GridItem>
                                        </GridItem>
                                    </GridContainer>
                                </CardBody>
                            </Card>
                        </GridItem>
                    </GridContainer>
                </div>
            );
        else return (
            <div>
                <Loader/>
            </div>
        )
    }
}
export default withStyles(styles)(ProfileView);



// WEBPACK FOOTER //
// ./src/components/Profile/viewProfile.jsx